import React from 'react';

// Logo Option 1: Iris Eye with Hexagon (Current)
export const Logo1 = ({ width = "60", height = "60" }) => (
  <svg width={width} height={height} viewBox="0 0 100 100" fill="none">
    <path d="M50 10 L75 25 L75 55 L50 70 L25 55 L25 25 Z" fill="url(#hex1)" stroke="#06B6D4" strokeWidth="2"/>
    <circle cx="50" cy="40" r="18" fill="#E0F2FE"/>
    <circle cx="50" cy="40" r="12" fill="#38BDF8"/>
    <circle cx="50" cy="40" r="7" fill="#0066CC"/>
    <circle cx="52" cy="37" r="3" fill="white"/>
    <line x1="50" y1="60" x2="40" y2="72" stroke="white" strokeWidth="2"/>
    <line x1="50" y1="60" x2="50" y2="75" stroke="white" strokeWidth="2"/>
    <line x1="50" y1="60" x2="60" y2="72" stroke="white" strokeWidth="2"/>
    <circle cx="40" cy="72" r="3" fill="white"/>
    <circle cx="50" cy="75" r="3" fill="white"/>
    <circle cx="60" cy="72" r="3" fill="white"/>
    <defs>
      <linearGradient id="hex1" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#1E3A8A"/>
        <stop offset="100%" stopColor="#06B6D4"/>
      </linearGradient>
    </defs>
  </svg>
);

// Logo Option 2: Network Mesh
export const Logo2 = ({ width = "60", height = "60" }) => (
  <svg width={width} height={height} viewBox="0 0 100 100" fill="none">
    <circle cx="50" cy="50" r="45" fill="url(#grad2)" stroke="#06B6D4" strokeWidth="2"/>
    <circle cx="50" cy="25" r="6" fill="white"/>
    <circle cx="75" cy="40" r="6" fill="white"/>
    <circle cx="75" cy="60" r="6" fill="white"/>
    <circle cx="50" cy="75" r="6" fill="white"/>
    <circle cx="25" cy="60" r="6" fill="white"/>
    <circle cx="25" cy="40" r="6" fill="white"/>
    <line x1="50" y1="25" x2="75" y2="40" stroke="white" strokeWidth="2"/>
    <line x1="75" y1="40" x2="75" y2="60" stroke="white" strokeWidth="2"/>
    <line x1="75" y1="60" x2="50" y2="75" stroke="white" strokeWidth="2"/>
    <line x1="50" y1="75" x2="25" y2="60" stroke="white" strokeWidth="2"/>
    <line x1="25" y1="60" x2="25" y2="40" stroke="white" strokeWidth="2"/>
    <line x1="25" y1="40" x2="50" y2="25" stroke="white" strokeWidth="2"/>
    <circle cx="50" cy="50" r="8" fill="#06B6D4"/>
    <defs>
      <linearGradient id="grad2" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#0066CC"/>
        <stop offset="100%" stopColor="#1E3A8A"/>
      </linearGradient>
    </defs>
  </svg>
);

// Logo Option 3: Lock Circuit
export const Logo3 = ({ width = "60", height = "60" }) => (
  <svg width={width} height={height} viewBox="0 0 100 100" fill="none">
    <rect x="30" y="45" width="40" height="45" rx="5" fill="url(#grad3)" stroke="#06B6D4" strokeWidth="2"/>
    <path d="M35 45 L35 35 Q35 20 50 20 Q65 20 65 35 L65 45" stroke="white" strokeWidth="3" fill="none"/>
    <circle cx="50" cy="67" r="8" fill="white"/>
    <rect x="47" y="67" width="6" height="15" fill="white"/>
    <circle cx="40" cy="30" r="2" fill="#06B6D4"/>
    <circle cx="60" cy="30" r="2" fill="#06B6D4"/>
    <line x1="25" y1="50" x2="30" y2="50" stroke="#06B6D4" strokeWidth="2"/>
    <line x1="70" y1="50" x2="75" y2="50" stroke="#06B6D4" strokeWidth="2"/>
    <defs>
      <linearGradient id="grad3" x1="0%" y1="0%" x2="0%" y2="100%">
        <stop offset="0%" stopColor="#1E3A8A"/>
        <stop offset="100%" stopColor="#0066CC"/>
      </linearGradient>
    </defs>
  </svg>
);

// Logo Option 4: DNA Helix Data
export const Logo4 = ({ width = "60", height = "60" }) => (
  <svg width={width} height={height} viewBox="0 0 100 100" fill="none">
    <circle cx="50" cy="50" r="45" fill="url(#grad4)"/>
    <path d="M30 20 Q40 35 30 50 Q20 65 30 80" stroke="white" strokeWidth="3" fill="none"/>
    <path d="M70 20 Q60 35 70 50 Q80 65 70 80" stroke="white" strokeWidth="3" fill="none"/>
    <line x1="30" y1="25" x2="70" y2="25" stroke="white" strokeWidth="2"/>
    <line x1="30" y1="40" x2="70" y2="40" stroke="white" strokeWidth="2"/>
    <line x1="30" y1="50" x2="70" y2="50" stroke="white" strokeWidth="2"/>
    <line x1="30" y1="60" x2="70" y2="60" stroke="white" strokeWidth="2"/>
    <line x1="30" y1="75" x2="70" y2="75" stroke="white" strokeWidth="2"/>
    <circle cx="30" cy="25" r="3" fill="#06B6D4"/>
    <circle cx="70" cy="25" r="3" fill="#06B6D4"/>
    <circle cx="30" cy="50" r="3" fill="#06B6D4"/>
    <circle cx="70" cy="50" r="3" fill="#06B6D4"/>
    <circle cx="30" cy="75" r="3" fill="#06B6D4"/>
    <circle cx="70" cy="75" r="3" fill="#06B6D4"/>
    <defs>
      <linearGradient id="grad4" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#0066CC"/>
        <stop offset="100%" stopColor="#1E3A8A"/>
      </linearGradient>
    </defs>
  </svg>
);

// Logo Option 5: Radar Pulse
export const Logo5 = ({ width = "60", height = "60" }) => (
  <svg width={width} height={height} viewBox="0 0 100 100" fill="none">
    <circle cx="50" cy="50" r="45" fill="url(#grad5)"/>
    <circle cx="50" cy="50" r="35" fill="none" stroke="white" strokeWidth="1.5" opacity="0.4"/>
    <circle cx="50" cy="50" r="25" fill="none" stroke="white" strokeWidth="1.5" opacity="0.6"/>
    <circle cx="50" cy="50" r="15" fill="none" stroke="white" strokeWidth="2" opacity="0.8"/>
    <circle cx="50" cy="50" r="6" fill="white"/>
    <line x1="50" y1="50" x2="50" y2="15" stroke="#06B6D4" strokeWidth="3" strokeLinecap="round">
      <animateTransform attributeName="transform" type="rotate" from="0 50 50" to="360 50 50" dur="4s" repeatCount="indefinite"/>
    </line>
    <circle cx="50" cy="25" r="3" fill="#06B6D4"/>
    <circle cx="65" cy="35" r="2" fill="white" opacity="0.7"/>
    <circle cx="35" cy="40" r="2" fill="white" opacity="0.7"/>
    <defs>
      <radialGradient id="grad5">
        <stop offset="0%" stopColor="#1E3A8A"/>
        <stop offset="100%" stopColor="#0066CC"/>
      </radialGradient>
    </defs>
  </svg>
);

// Logo Option 6: Data Shield
export const Logo6 = ({ width = "60", height = "60" }) => (
  <svg width={width} height={height} viewBox="0 0 100 100" fill="none">
    <path d="M50 10 L85 25 L85 50 Q85 75 50 90 Q15 75 15 50 L15 25 Z" fill="url(#grad6)" stroke="#06B6D4" strokeWidth="2"/>
    <path d="M30 40 L45 55 L70 30" stroke="white" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
    <line x1="25" y1="35" x2="75" y2="35" stroke="white" strokeWidth="1" opacity="0.3"/>
    <line x1="25" y1="45" x2="75" y2="45" stroke="white" strokeWidth="1" opacity="0.3"/>
    <line x1="25" y1="55" x2="75" y2="55" stroke="white" strokeWidth="1" opacity="0.3"/>
    <line x1="25" y1="65" x2="75" y2="65" stroke="white" strokeWidth="1" opacity="0.3"/>
    <defs>
      <linearGradient id="grad6" x1="0%" y1="0%" x2="0%" y2="100%">
        <stop offset="0%" stopColor="#0066CC"/>
        <stop offset="100%" stopColor="#1E3A8A"/>
      </linearGradient>
    </defs>
  </svg>
);

// Logo Option 7: Neural Brain
export const Logo7 = ({ width = "60", height = "60" }) => (
  <svg width={width} height={height} viewBox="0 0 100 100" fill="none">
    <circle cx="50" cy="50" r="40" fill="url(#grad7)" stroke="#06B6D4" strokeWidth="2"/>
    <path d="M30 35 Q35 30 40 35 Q45 40 40 45" stroke="white" strokeWidth="2.5" fill="none"/>
    <path d="M60 35 Q65 30 70 35 Q75 40 70 45" stroke="white" strokeWidth="2.5" fill="none"/>
    <path d="M35 60 Q50 70 65 60" stroke="white" strokeWidth="2.5" fill="none"/>
    <circle cx="30" cy="40" r="3" fill="white"/>
    <circle cx="45" cy="38" r="3" fill="white"/>
    <circle cx="55" cy="38" r="3" fill="white"/>
    <circle cx="70" cy="40" r="3" fill="white"/>
    <circle cx="40" cy="55" r="3" fill="white"/>
    <circle cx="60" cy="55" r="3" fill="white"/>
    <line x1="30" y1="40" x2="45" y2="38" stroke="white" strokeWidth="1" opacity="0.5"/>
    <line x1="55" y1="38" x2="70" y2="40" stroke="white" strokeWidth="1" opacity="0.5"/>
    <line x1="45" y1="38" x2="40" y2="55" stroke="white" strokeWidth="1" opacity="0.5"/>
    <line x1="55" y1="38" x2="60" y2="55" stroke="white" strokeWidth="1" opacity="0.5"/>
    <defs>
      <radialGradient id="grad7">
        <stop offset="0%" stopColor="#1E3A8A"/>
        <stop offset="100%" stopColor="#0066CC"/>
      </radialGradient>
    </defs>
  </svg>
);

// Logo Option 8: Crystal Cube
export const Logo8 = ({ width = "60", height = "60" }) => (
  <svg width={width} height={height} viewBox="0 0 100 100" fill="none">
    <path d="M50 15 L80 35 L80 65 L50 85 L20 65 L20 35 Z" fill="url(#grad8)" stroke="#06B6D4" strokeWidth="2"/>
    <path d="M50 15 L50 85" stroke="white" strokeWidth="1.5" opacity="0.6"/>
    <path d="M20 35 L80 65" stroke="white" strokeWidth="1.5" opacity="0.6"/>
    <path d="M80 35 L20 65" stroke="white" strokeWidth="1.5" opacity="0.6"/>
    <circle cx="50" cy="50" r="8" fill="#06B6D4"/>
    <circle cx="50" cy="50" r="4" fill="white"/>
    <circle cx="50" cy="15" r="3" fill="white"/>
    <circle cx="80" cy="35" r="3" fill="white"/>
    <circle cx="80" cy="65" r="3" fill="white"/>
    <circle cx="50" cy="85" r="3" fill="white"/>
    <circle cx="20" cy="65" r="3" fill="white"/>
    <circle cx="20" cy="35" r="3" fill="white"/>
    <defs>
      <linearGradient id="grad8" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#0066CC"/>
        <stop offset="50%" stopColor="#1E3A8A"/>
        <stop offset="100%" stopColor="#06B6D4"/>
      </linearGradient>
    </defs>
  </svg>
);

// Logo Option 9: Infinity Network
export const Logo9 = ({ width = "60", height = "60" }) => (
  <svg width={width} height={height} viewBox="0 0 100 100" fill="none">
    <circle cx="50" cy="50" r="45" fill="url(#grad9)"/>
    <path d="M25 50 Q35 30 50 50 Q65 70 75 50 Q65 30 50 50 Q35 70 25 50" fill="none" stroke="white" strokeWidth="4" strokeLinecap="round"/>
    <circle cx="30" cy="50" r="5" fill="white"/>
    <circle cx="70" cy="50" r="5" fill="white"/>
    <circle cx="50" cy="50" r="5" fill="#06B6D4"/>
    <circle cx="40" cy="40" r="3" fill="white" opacity="0.7"/>
    <circle cx="60" cy="60" r="3" fill="white" opacity="0.7"/>
    <circle cx="40" cy="60" r="3" fill="white" opacity="0.7"/>
    <circle cx="60" cy="40" r="3" fill="white" opacity="0.7"/>
    <defs>
      <linearGradient id="grad9" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#1E3A8A"/>
        <stop offset="100%" stopColor="#0066CC"/>
      </linearGradient>
    </defs>
  </svg>
);

// Logo Option 10: Quantum Particle
export const Logo10 = ({ width = "60", height = "60" }) => (
  <svg width={width} height={height} viewBox="0 0 100 100" fill="none">
    <circle cx="50" cy="50" r="45" fill="url(#grad10)"/>
    <circle cx="50" cy="50" r="12" fill="white"/>
    <circle cx="50" cy="50" r="8" fill="#06B6D4"/>
    <ellipse cx="50" cy="50" rx="35" ry="15" fill="none" stroke="white" strokeWidth="2" opacity="0.7"/>
    <ellipse cx="50" cy="50" rx="35" ry="15" fill="none" stroke="white" strokeWidth="2" opacity="0.7" transform="rotate(60 50 50)"/>
    <ellipse cx="50" cy="50" rx="35" ry="15" fill="none" stroke="white" strokeWidth="2" opacity="0.7" transform="rotate(120 50 50)"/>
    <circle cx="50" cy="20" r="4" fill="white"/>
    <circle cx="73" cy="35" r="4" fill="white"/>
    <circle cx="73" cy="65" r="4" fill="white"/>
    <circle cx="50" cy="80" r="4" fill="white"/>
    <circle cx="27" cy="65" r="4" fill="white"/>
    <circle cx="27" cy="35" r="4" fill="white"/>
    <defs>
      <radialGradient id="grad10">
        <stop offset="0%" stopColor="#0066CC"/>
        <stop offset="100%" stopColor="#1E3A8A"/>
      </radialGradient>
    </defs>
  </svg>
);
